import { useTranslation } from 'react-i18next';
import { PayoutDestinationType } from 'services/payouts/types';

import { DataTableCellProps, TableCell } from 'components/dataTable';

import { LABELS, PAYOUT_COLUMNS_IDS } from '../../keys';
import { PayoutType } from '../payoutModal/types';

export const PaymentTypeCell = ({ row, column }: DataTableCellProps) => {
  const { t } = useTranslation();
  const value = row[PAYOUT_COLUMNS_IDS.TYPE];
  if (!value) {
    return null;
  }

  const label =
    value === PayoutDestinationType.BANK_ACCOUNT ? t(LABELS.PAYOUT.TYPES[PayoutType.Fiat]) : t(LABELS.PAYOUT.TYPES[PayoutType.Crypto]);

  return <TableCell data-column={column.id}>{label}</TableCell>;
};
